<template lang="pug">
server-data(
  v-if="$user && $user.isMember"
  v-model="duplicate"
  :key="$user && $user.data && $user.data.id"
  :method="getUserDuplacate"
  :serialize-data="resp => resp.item"
  start-loading-value
  @input="(v) => v && openDialog()"
  v-slot="{ loading }"
)
  portal(
    v-if="dialogId && duplicate && !loading"
    :to="`${dialogId}.content`"
    v-slot="{ close }"
  )
    .d-flex.flex-column.gap-16
      h2.mt-8 Ваш аккаунт сливается с другим
      p.ui-body-1
        | Слияние происходит с аккаунтом пользователя #[strong {{ duplicate.other_user.profile.public_name }}]
      p.ui-body-1.mt-2
        | Процесс завершится #[strong {{ (merge && merge.merge_at) | localeFormat }}],
        | после чего этот аккаунт уже перестанет быть доступен
      dv-btn.full-width.mt-4(
        x-large
        @click="logout(); close();"
      ) Выйти
      server-data(
        :method="deleteDuplicate"
        no-init
        @data:init="close"
        v-slot="{ init, loading: deleteLoading }"
      )
        dv-btn.full-width(
          text
          color="ui-error"
          :loading="deleteLoading"
          @click="init"
        ) Отменить слияние
</template>

<script>
import { USER_DUPLICATE_STATUS_KEY } from '@/modules/UserDuplicatesMerges/components/constants';
import DvBtn from '@/packages/ui/components/buttons/DvBtn.vue';
import { localeFormat } from '@/plugins/date-print';

export default {
  components: {
    DvBtn,
  },
  props: {},
  filters: {
    localeFormat,
  },
  data() {
    return {
      dialogId: undefined,
      duplicate: undefined,
    };
  },
  computed: {
    merge() {
      if (this.duplicate?.isPendingDispatcherMerge) return this.duplicate.pendingMerge;
      const [item] = this.duplicate?.user_duplicate_merges || [];
      return item;
    },
  },
  watch: {
    '$user.isAuthenticated': {
      handler() {
        this.duplicate = undefined;
      },
    },
  },
  methods: {
    async getUserDuplacate() {
      const params = {
        'search[users_exists]': 1,
        'search[status]': [USER_DUPLICATE_STATUS_KEY.wait].join(','),
        expand: 'other_user,user_duplicate_merges',
      };
      const { items = [], ...other } = await this.$models.users.duplicates.indexWithMerges({ params });
      const legacyItems = items.filter((item) => !item.isPendingDispatcherMerge);
      const dispatcherItems = items.filter((item) => item.isPendingDispatcherMerge && item.pendingMerge.owner_id !== this.$user.data.id);
      const [item] = [...legacyItems, ...dispatcherItems];
      const merge = item?.isPendingDispatcherMerge ? item.pendingMerge : item?.user_duplicate_merges?.[0];
      return {
        item: merge?.owner_id !== this.$user?.data?.id ? item : undefined,
        ...other,
      };
    },
    openDialog() {
      this.dialogId = this.$dialogs.portal({
        attrs: {
          'max-width': 700,
          hideHeader: true,
          persistent: true,
          scrollable: false,
          hideActions: true,
          zIndex: 1005,
        },
      });
    },
    async deleteDuplicate() {
      return this.$models.users.duplicates.cancel({ args: [this.duplicate.id] });
    },
    async logout() {
      await this.$store.dispatch('auth/logout');
      this.$router.push('/');
    },
  },
};
</script>
